<template>
  <div>
    <navigation ref="navigation"></navigation>
    <div style="border-left:1px #e1e1e1 solid;border-right:1px #e1e1e1 solid;width:1000px;margin:0 auto;background: #fff">
      <div class="new_content">
        <div class="new_findPwd_title" style="display: none">
          <router-link to="/findByMobile" class="new_findPwd_title_sel" >手机找回密码</router-link>
        </div>
          <div class="new_findPwd_main" style="border:0;width:80%; margin: 0 auto;">
            <el-steps :space="350" :active="active" finish-status="success" style="margin-left: 50px; margin-bottom: 30px;">
              <el-step title="验证手机号"></el-step>
              <el-step title="设置密码"></el-step>
              <el-step title="设置成功"></el-step>
            </el-steps>
            <div v-show="active==1">
              <el-form ref="mobileForm" :model="mobileForm" label-width="100px" :rules="mobileRules" >
                <el-form-item label="手机号" prop="mobile">
                  <el-input v-model="mobileForm.mobile" style="width: 50%" ></el-input><el-button type="primary" size="small" style="margin-left: 20px;" @click.native = "sendSmsMethod" :disabled="sendSmsButtonDisabled">{{sendSmsButtonText}}</el-button>
                </el-form-item>
                <el-form-item label="验证码" prop="mobileCode" >
                  <el-input v-model="mobileForm.mobileCode" style="width: 20%" ></el-input> <a href="javascript:;" class="yz ml-20 pa" title="①手机接收短信偶尔会有延时状况，请耐心等待;②尝试到手机短信拦截记录里找找看;③若有疑问请拨打客服电话：400-004-2055"> 没有收到验证码？</a>
                </el-form-item>
                <el-form-item  style="text-align: center;padding-top: 30px;">
                  <el-button type="primary" style="width:30%;" @click.native = "nextMobile">下一步</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-show="active==2">
              <el-form ref="pwdForm" :model="pwdForm" label-width="100px" :rules="pwdRules" >
                <el-form-item label="新密码" prop="newPwd">
                  <el-input v-model="pwdForm.newPwd" type="password" style="width: 50%" ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="reNewPwd" >
                  <el-input v-model="pwdForm.reNewPwd"  type="password"   style="width: 50%" ></el-input>
                </el-form-item>
                <el-form-item  style="text-align: center;">
                  <el-button type="primary" style="width:30%;" @click = "updatePwd">确定</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-show="active==3">
              <div class="new_content">
                <div style="padding:5% 0;">
                  <p class="new_zc_sucess">找回密码成功! </p>
                  <p class="new_zc_welcome"><span>{{userName}}</span>欢迎回来&nbsp;|&nbsp;<router-link to="/">立即登录</router-link></p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <footer1></footer1>
    <div id="J_GotoTop" class="elevator">
      <a href="javascript:void(0)" class="elevator-msg" onclick="doyoo.util.openChat('g=89472'); return false;">
        <i class="iconfont icon-kefu"></i>
        <span class="">在线客服</span>
      </a>
    </div>
  </div>
</template>
<style scoped>
  .new_findPwd_title{height:37px; padding-top:40px;}
  .new_findPwd_title a{display:block; float:left;width:130px; height:36px; line-height:36px; text-align:center;border:#c9c9c9 1px solid; border-bottom:0px; margin-right:12px;color:#5f5f5f;}
  .new_findPwd_title a.new_findPwd_title_sel{background:#9f1b29; color:#fff;border:#9f1b29 1px solid; border-bottom:0px;}
  .new_fpwx_title{color:#9f1b29;font-weight:bold; text-align:left; line-height:40px;}
  .new_fpwx_img{text-align:center;}
  .new_findPwd_main{width:100%; min-height: 340px;border:1px #c9c9c9 solid; padding: 40px 0px 0px 0px;}
  p.new_zc_sucess{width:245px; padding-left:36px; text-align:left; background:url(../assets/img/sucess_bg.gif) no-repeat left center; height:40px; line-height:40px; font-size:30px; margin:0px auto; color:#66a000;}
  p.new_zc_welcome{text-align: center; font-size: 14px; line-height: 40px;}
  p.new_zc_welcome span, p.new_zc_welcome a{color:#ff5300;}
  p.new_zc_welcome a:hover{text-decoration: underline}


  .elevator {
    position: fixed;
    padding: 0 16px;
    top: 249px;
    /*margin-top: -140px;*/
    right: 0;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0 4px 12px 0 rgba(7, 17, 27, .1)
  }

  .elevator a {
    display: block;
    width: 26px;
    padding: 16px 0;
    font-size: 22px;
    line-height: 20px;
    color: #b5b9bc;
    box-sizing: border-box;
    text-align: center;
    border-bottom: 1px solid #edf1f2
  }

  .elevator a:hover {
    color: #14191e
  }

  .elevator a i {
    font-size: 24px;
    color: #b5b9bc
  }

  .elevator a i:hover {
    color: #14191e
  }

  .elevator a span {
    display: none;
    font-size: 12px;
    color: #f01414;
    line-height: 12px
  }

  .elevator .no-goto {
    border-bottom: none
  }

  .elevator .elevator-app:hover i, .elevator .elevator-faq:hover i, .elevator .elevator-msg:hover i, .elevator .elevator-top:hover i, .elevator .elevator-weixin:hover i {
    display: none
  }

  .elevator .elevator-app:hover span, .elevator .elevator-faq:hover span, .elevator .elevator-msg:hover span, .elevator .elevator-top:hover span, .elevator .elevator-weixin:hover span {
    display: inline-block
  }

  .elevator .elevator-app-box {
    position: absolute;
    width: 172px;
    height: 212px;
    bottom: -2px;
    right: 56px;
    -webkit-transition: opacity .25s, transform .3s;
    -moz-transition: opacity .25s, transform .3s;
    transition: opacity .25s, transform .3s;
    opacity: 0;
    filter: alpha(opacity=0);
    max-width: 0;
    -webkit-transform: scale(.01);
    -ms-transform: scale(.01);
    transform: scale(.01);
    -webkit-transform-origin: 100% 95%;
    -ms-transform-origin: 100% 95%;
    transform-origin: 100% 95%;
  }

  .elevator .elevator-app:hover .elevator-app-box {
    display: block;
    visibility: visible;
    opacity: 1;
    filter: alpha(opacity=100);
    max-width: none;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1)
  }

  .elevator .elevator-weixin-box {
    position: absolute;
    width: 172px;
    height: 212px;
    bottom: -4px;
    right: 56px;
    -webkit-transition: opacity .25s, transform .3s;
    -moz-transition: opacity .25s, transform .3s;
    transition: opacity .25s, transform .3s;
    opacity: 0;
    filter: alpha(opacity=0);
    max-width: 0;
    -webkit-transform: scale(.01);
    -ms-transform: scale(.01);
    transform: scale(.01);
    -webkit-transform-origin: 100% 95%;
    -ms-transform-origin: 100% 95%;
    transform-origin: 100% 95%;
  }

  .elevator .elevator-weixin:hover .elevator-weixin-box {
    display: block;
    visibility: visible;
    opacity: 1;
    filter: alpha(opacity=100);
    max-width: none;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1)
  }
</style>

<script>

  import navigation from '../components/Navigation'
  import footer1 from '../components/Footer1'

  import sha256 from 'crypto-js/sha256'

  import {
    sendSms,
    vftelStudent,
    validateMobileCode,
    updatePwd,
  } from '../api/api';

  export default {
    components: {
      navigation,
      footer1
    },
    data () {
      var validateMobile = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入手机号'));
        } else if (!(/^1[3|4|5|7|8][0-9]\d{4,8}$/.test(value))) {
          callback(new Error('请输入正确的手机号'));
        } else {
          vftelStudent({tel: value}).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (!data) {
                callback(new Error('手机号未验证，请使用微信找回密码！'));
              } else {
                callback();
              }
            }
          })
        }
      };
      var validateVPhoneCode = (rule, value, callback) => {
        if (!this.mobileForm.mobile) {
          callback(new Error('请先获取手机验证码'));
        } else if (!value) {
          callback(new Error('请输入手机验证码'));
        } else {
          validateMobileCode({mobile: this.mobileForm.mobile, code: value}).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (data.status == 200) {
                callback();
              } else {
                callback(new Error('手机验证码错误'));
              }
            }
          })
        }
      };
      var validateVpassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.pwdForm.newPwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        mobileForm:{
          mobile:'',
          mobileCode:'',
          newPwd:'',
          reNewPwd:''
        },
        pwdForm:{
          newPwd:'',
          reNewPwd:''
        },
        active: 1,
        userName:'',
        sendSmsButtonDisabled:false,
        smsTime:0,
        mobileRules:{
          mobile: [
            {validator: validateMobile, trigger: 'blur'}
          ],
          mobileCode: [
            {validator: validateVPhoneCode, trigger: 'blur'}
          ],
        },
        pwdRules:{
          newPwd: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min: 6, max: 22, message: '长度在 6 到 22 个字符', trigger: 'blur'}
          ],
          reNewPwd: [
            {validator: validateVpassword, trigger: 'blur'}
          ],
        }
      }
    },
    computed: {
      sendSmsButtonText() {
        const _this=this;
        if (this.smsTime > 0) {
          if (!this.sendSmsButtonDisabled) {
            _this.sendSmsButtonDisabled = true
          }
          return this.smsTime + 's 后重新获取'
        } else {
          _this.sendSmsButtonDisabled = false
          return '获取验证码'
        }
      },
    },
    methods:{
      smsTimer() {
        if (this.smsTime > 0) {
          this.smsTime--;
          setTimeout(this.smsTimer, 1000);
        }
      },
      sendSmsMethod(){
        this.$refs.mobileForm.validateField('mobile', error => {
          if (!error) {
            let timestamp = new Date().getTime();
            let sign = sha256(this.mobileForm.mobile + 3 + timestamp).toString()
            let param = {
              mobile: this.mobileForm.mobile,
              bType: 3,
              sign: sign,
              timestamp: timestamp,
            }
            sendSms(param).then((response) => {
              let {data} = response
              if (response.status == 200) {
                if (data.status == 200) {
                  this.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  this.smsTime = 60
                  this.smsTimer()
                } else {
                  this.$message({
                    message: data.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message.error('网络错误！');
              }
            })
          }
        })
      },

      nextMobile() {
        this.$refs.mobileForm.validate((valid) => {
          if (valid) {
            if (this.active++ > 2) this.active = 0;
          }else{
            return false;
          }
        });
      },

      updatePwd() {
        this.$refs.pwdForm.validate((valid) => {
          if (valid) {
            let param = {newPwd:this.pwdForm.newPwd,prama:this.mobileForm.mobile,type:1};
            updatePwd(param).then((response) => {
              if (response.status == 200) {
                if (response.data.state == 1) {
                  this.userName = response.data.userName;
                  if (this.active++ > 2) this.active = 0;
                } else {
                  this.$message({
                    message: '操作失败！请刷新后再试！',
                    type: 'warning'
                  });
                }
              } else {
                this.$message.error('网络错误！');
              }
            })
          }else{
            return false;
          }
        });
      },
    }
   }

</script>
